/** @module Components */

import React from 'react'

export const ScdCentersWorkshop: React.FC = () => {
  return (
    <main className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-6">
          2026 NASCC SCD Centers Workshop
        </h1>

        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-8">
          <div className="space-y-6">
            <div>
              <h2 className="text-xl md:text-2xl font-serif text-[#A6410A] mb-3">
                When
              </h2>
              <p className="text-[#3C2416] text-base md:text-lg leading-relaxed">
                The National Alliance of Sickle Cell Centers (NASCC) is pleased
                to announce the 2026 Sickle Cell Centers Workshop Program, an
                in-person workshop taking place{' '}
                <strong>July 24–26, 2026, in Madison, Wisconsin</strong>{' '}
                immediately prior to the NASCC Annual SCD Centers meeting.
              </p>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-serif text-[#A6410A] mb-3">
                What
              </h2>
              <p className="text-[#3C2416] text-base md:text-lg leading-relaxed">
                The SCD centers workshop was initially organized and implemented
                by the American Society of Hematology and (over 5
                years)-contributed to the establishment of 58 new adult sickle
                cell centers. At this time, the NASCC will continue to support
                this workshop to further advance its reach and impact through
                continued collaboration, innovation, and a shared commitment to
                improving comprehensive SCD care.
              </p>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-serif text-[#A6410A] mb-3">
                Why
              </h2>
              <p className="text-[#3C2416] text-base md:text-lg leading-relaxed">
                This interactive workshop is designed to support the development
                and strengthening of comprehensive sickle cell centers, with a
                focus on evidence-based care models, improving access to care,
                and equipping clinicians, program leaders, and multidisciplinary
                teams with practical strategies to build sustainable,
                high-quality programs.
              </p>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-serif text-[#A6410A] mb-3">
                How to Apply
              </h2>
              <p className="text-[#3C2416] text-base md:text-lg leading-relaxed">
                Please apply using the link below. Note that the application is
                submitted through ASH (and the link will bring you to their
                website where you have to create a login), but the workshop is
                hosted in its entirety by NASCC.
              </p>
              <div className="mt-4">
                <a
                  href="https://apps.hematology.org/Awards/Applications/awards/termsandconditions?awardCode=ASCDW&awardYear=2026&phaseId=2451"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#142841] text-white px-6 py-3 rounded-md text-base md:text-lg font-medium hover:bg-[#1e3a5c] transition-colors"
                >
                  Apply Now
                </a>
              </div>
            </div>

            <div className="bg-[#EDE6DE] rounded-lg p-4 md:p-6 mt-6">
              <p className="text-[#A6410A] text-lg md:text-xl font-semibold">
                Application Deadline: February 13, 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
